/** OccluderInstance3D parser: the Node3D parse plus the occluder it holds. */
import { parseNode3D } from '../../base/node3d/parser';
export function parseOccluderInstance3D(heading, properties) {
    return { ...parseNode3D(heading, properties), occluder: properties.occluder };
}
//# sourceMappingURL=parser.js.map